import React from 'react';
import { Box, Flex, Text, Badge, Divider, Image, Button } from '@chakra-ui/react';
import { Package, Calendar, CheckCircle2 } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
export const Orders: React.FC = () => {
  const {
    orders,
    adminSettings
  } = useAppContext();
  const navigate = useNavigate();
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Pending':
        return 'orange';
      case 'Confirmed':
        return 'blue';
      case 'Packed':
        return 'purple';
      case 'Out for Delivery':
        return 'teal';
      case 'Delivered':
        return 'green';
      case 'Cancelled':
        return 'red';
      default:
        return 'gray';
    }
  };
  if (orders.length === 0) {
    return <Flex direction="column" align="center" justify="center" minH="70vh" p={4} bg="white" className={adminSettings.animationsEnabled ? 'animate-fade-in' : ''} data-id="element-510">
        <Box className={adminSettings.animationsEnabled ? 'animate-float' : ''} mb={4} data-id="element-511">
          <Box bg="gray.100" p={5} borderRadius="full" data-id="element-512">
            <Package size={48} color="var(--chakra-colors-gray-400)" data-id="element-513" />
          </Box>
        </Box>
        <Text fontSize="lg" fontWeight="700" color="gray.700" data-id="element-514">
          No orders yet
        </Text>
        <Text mt={2} fontSize="sm" color="gray.400" textAlign="center" data-id="element-515">
          Start shopping to see your orders here
        </Text>
        <Button mt={6} bg={adminSettings.accentColor} color="white" borderRadius="12px" px={8} onClick={() => navigate('/products')} data-id="element-516">
          Browse Products
        </Button>
      </Flex>;
  }
  return <Box bg="gray.50" minH="100%" p={3} pb="80px" className={adminSettings.animationsEnabled ? 'animate-fade-in' : ''} data-id="element-517">
      <Text fontSize="lg" fontWeight="700" mb={4} px={1} color="gray.800" data-id="element-518">
        My Orders
      </Text>
      {orders.map((order, idx) => <Box key={order.id} bg="white" p={4} mb={3} borderRadius="14px" shadow="sm" className={adminSettings.animationsEnabled ? 'animate-slide-up' : ''} style={adminSettings.animationsEnabled ? {
      animationDelay: `${idx * 0.05}s`
    } : {}} data-id="element-519">
          <Flex justify="space-between" align="center" mb={3} data-id="element-520">
            <Box data-id="element-521">
              <Text fontSize="10px" color="gray.400" fontWeight="500" data-id="element-522">
                Order ID
              </Text>
              <Text fontSize="sm" fontWeight="700" data-id="element-523">
                {order.id}
              </Text>
            </Box>
            <Badge colorScheme={getStatusColor(order.status)} px={2} py={1} borderRadius="8px" fontSize="10px" fontWeight="600" data-id="element-524">
              {order.status}
            </Badge>
          </Flex>

          <Divider my={2} data-id="element-525" />

          {order.items.map((item, i) => <Flex key={i} py={2} gap={3} align="center" data-id="element-526">
              <Image src={item.images[0]} w="44px" h="44px" objectFit="cover" borderRadius="10px" data-id="element-527" />
              <Box flex={1} data-id="element-528">
                <Text fontSize="xs" fontWeight="600" noOfLines={1} data-id="element-529">
                  {item.title}
                </Text>
                <Text fontSize="10px" color="gray.400" data-id="element-530">
                  Qty: {item.quantity}{' '}
                  {item.selectedSize ? `· ${item.selectedSize}` : ''}
                </Text>
              </Box>
              <Text fontSize="xs" fontWeight="700" data-id="element-531">
                ₹{item.discountPrice * item.quantity}
              </Text>
            </Flex>)}

          <Divider my={2} data-id="element-532" />

          <Box mt={2} mb={2} data-id="element-533">
            {order.status === 'Delivered' && order.deliveryDate ? <Flex align="center" gap={1} color="green.600" data-id="element-534">
                <CheckCircle2 size={14} data-id="element-535" />
                <Text fontSize="xs" fontWeight="600" data-id="element-536">
                  Delivered on {order.deliveryDate}
                </Text>
              </Flex> : order.expectedDeliveryDate ? <Flex align="center" gap={1} color="blue.600" data-id="element-537">
                <Calendar size={14} data-id="element-538" />
                <Text fontSize="xs" fontWeight="600" data-id="element-539">
                  Expected Delivery: {order.expectedDeliveryDate}
                </Text>
              </Flex> : null}
          </Box>

          <Flex justify="space-between" align="center" mt={1} data-id="element-540">
            <Text fontSize="10px" color="gray.400" data-id="element-541">
              Ordered: {order.date}
            </Text>
            <Flex align="center" gap={2} data-id="element-542">
              {order.promoCode && <Badge colorScheme="green" fontSize="8px" data-id="element-543">
                  Promo Applied
                </Badge>}
              <Text fontSize="sm" fontWeight="800" color={adminSettings.accentColor} data-id="element-544">
                ₹{order.total}
              </Text>
            </Flex>
          </Flex>
        </Box>)}
    </Box>;
};